import Cashouts from '../../services/cashout.service';
import { showSnackBar } from './snackbar.actions';

/** Actions types ***/

export const SET_CASHOUTS_LIST = '[CASHOUT] SET LIST';

//--------------------------
/** Actions **/

/**
 *
 * @param {Object} paginatedCashouts
 */
export const setCashoutsList = paginatedCashouts => {
  return {
    type: SET_CASHOUTS_LIST,
    paginatedCashouts,
  };
};

//--------------------------
/** Action creators **/

/**
 *
 * @param {Object} filters
 */
export const getCashoutsList = filters => {
  return dispatch => {
    Cashouts.list(filters)
      .then(response => {
        dispatch(setCashoutsList({ ...response.data }));
      })
      .catch(error => {
        dispatch(
          showSnackBar({
            message: 'Could not load the list of cashouts',
            type: 'error',
          }),
        );
      });
  };
};
